import React from 'react';

import { Button, Row, Col, Input, message, Spin, Table } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import TablePager from 'shared_components/table_pager';
import PageTitle from 'shared_components/page_title';
import { useState } from 'react';
import {
	GLOBAL_TABLE_PAGE_SIZE,
	GLOBAL_TABLE_SIZE,
	GLOBAL_TABLE_YSCROLL,
} from 'global_config/constant-global';
import './index.css';
import LotNoForm from './lotno_form';
import DataForm from './data_form';
import GenerationForm from './generate_form';
import { fetchQualityControlItems } from 'services/settings/qualityControl';

const { Search } = Input;

const QualityControl = () => {
	const [state, setState] = useState({
		loading: false,
		tableSize: GLOBAL_TABLE_PAGE_SIZE,
	});

	const [loading, setLoading] = useState(false);
	const [isShowLotNoForm, setIsShowLotNoForm] = useState(false);
	const [isShowDataForm, setIsShowDataForm] = useState(false);
	const [isShowGenerationForm, setIsShowGenerationForm] = useState(false);

	const [lotNo, setLotNo] = useState(null);

	const [lotNoRecord, setLotNoRecord] = useState(null);
	const [dataRecord, setdataRecord] = useState(null);
	const [generationRecord, setGenerationRecord] = useState(null);

	console.log('index recordLotNoRecord :', lotNoRecord);

	const handleLotNoRecord = record => {
		if (record) {
			setLotNoRecord(record);
		} else {
			setLotNoRecord(null);
		}
		setIsShowLotNoForm(true);
	};

	const handleDataRecord = record => {
		if (record) {
			setdataRecord(record);
		} else {
			setdataRecord({});
		}
		setIsShowDataForm(true);

		return null;
	};

	const handleGenerationForm = record => {
		if (record) {
			setGenerationRecord(record);
		} else {
			setGenerationRecord(null);
		}
		setIsShowGenerationForm(true);

		return null;
	};

	const columns = [
		{
			title: 'LOT NO.',
			dataIndex: 'lotno',
			width: 150,
		},
		{
			title: 'MACHINE',
			dataIndex: 'analyzername',
			width: 150,
		},
		{
			title: 'SECTION',
			dataIndex: 'sectionname',
			width: 150,
		},
		{
			title: 'EXAM',
			dataIndex: 'examname',
			width: 400,
		},
		{
			title: 'ACTION',
			dataIndex: '',
			width: 300,
			render: record => (
				<div
					style={{ display: 'flex', gap: '10px', alignItems: 'center' }}
					className="font-md leading-none"
				>
					<p className="hover leading-botton-0" onClick={() => handleLotNoRecord(record)}>
						UPDATE
					</p>
					|
					<p className="hover leading-botton-0" onClick={() => handleDataRecord(record)}>
						DATA
					</p>
					|
					<p className="hover leading-botton-0" onClick={() => handleGenerationForm(record)}>
						GENERATED FILES
					</p>
				</div>
			),
		},
	];

	const onSearch = async value => {
		if (value.length < 4) {
			message.error('Please enter at least 4 characters.');
			return;
		}

		console.log(value);

		try {
			const result = await fetchQualityControlItems(value);
			console.log(result.records);
			setLotNo(result.records);
		} catch (error) {
			console.log(error);
			setLotNo(null);
		}
	};

	const onChangePager = pageSize => {
		setState(prevState => ({
			...prevState,
			tableSize: pageSize,
		}));
	};

	const autoSearch = async value => {
		console.log(value);
		setLoading(true);
		setIsShowLotNoForm(false);

		if (value.length >= 4) {
			try {
				const result = await fetchQualityControlItems(value);
				console.log(result.records);
				setLotNo(result.records);
			} catch (error) {
				console.log(error);
				setLotNo(null);
			}
		} else {
			message.error('Please enter at least 4 characters.');
		}

		setLoading(false);
	};

	console.log(dataRecord);

	return (
		<div className="quality-control">
			<PageTitle pageTitle={'QUALITY CONTROL'} />
			<div className="space-y-md"></div>
			<div className="search-container">
				<Col className="search">
					<p style={{ margin: 0 }}>SEARCH</p>
					<Search allowClear onSearch={value => onSearch(value)} />
				</Col>
				<Col className="button">
					<Button
						shape="round"
						type="primary"
						onClick={() => handleLotNoRecord(null)}
						// disabled={selectedSectionId === null}
					>
						<PlusOutlined /> ADD LOT NO.
					</Button>

					<TablePager handleChange={onChangePager} />
				</Col>
			</div>

			<div className="space-y-sm"></div>

			<Spin spinning={loading} tip="Loading...">
				<Table
					size={state.tableSize}
					// pagination={{ pageSize, showSizeChanger: false }}
					pagination={false}
					columns={columns}
					dataSource={lotNo}
					// scroll={{ y: tableYScroll }}
					// rowKey={record => record.examItemID}
					// onRow={(record, index) => ({
					// 	index,
					// 	onDoubleClick: () => onRowDblClick(record)
					// })}
				/>
			</Spin>

			<LotNoForm
				visible={isShowLotNoForm}
				onClose={setIsShowLotNoForm}
				record={lotNoRecord}
				autoSearch={autoSearch}
			/>

			<DataForm visible={isShowDataForm} onClose={setIsShowDataForm} record={dataRecord} />

			<GenerationForm
				visible={isShowGenerationForm}
				onClose={setIsShowGenerationForm}
				record={generationRecord}
			/>
		</div>
	);
};

export default QualityControl;
